import React, {useState} from 'react'
import {HashLink as Link} from 'react-router-hash-link'
import './Navbar.css'
import { BrowserRouter } from 'react-router-dom';

function Navbar() {
  const [click, setClick] = useState(false);
  //const [button, setButton] = useState(true);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  // const showButton = () =>{
  //   if (window.innerWidth <= 960){
  //     setButton(false)
  //   }else{
  //     setButton(true)
  //   }
  // };

  // window.addEventListener('resize', showButton);
  
  return (
    <>
      <nav id='#navbar' className='navbar'>
            <div className='navbar-container'>
                <Link to = '/' className = 'navbar-title' onClick={closeMobileMenu}>Abigail Joseph</Link>
                <div className='menu-icon' onClick={handleClick}>
                    <i className={click ? 'fas fa-times': 'fas fa-bars'}/>
                  </div>
                    <ul className={click ? 'nav-menu-active': 'nav-menu'}>
                      <li className='nav-item'>
                        <Link to='#about' className='nav-links' onClick={closeMobileMenu}>
                          About
                        </Link>
                      </li>
                      {/* <li className='nav-item'>
                        <Link to='#experience' className='nav-links' onClick={closeMobileMenu}>
                          Experience
                        </Link>
                      </li> */}
                      <li className='nav-item'>
                        <Link to='#projects' className='nav-links' onClick={closeMobileMenu}>
                          Projects
                        </Link>
                      </li>
                      <li className='nav-item'>
                        <Link to='#contact' className='nav-links' onClick={closeMobileMenu}>
                          Contact
                        </Link>
                      </li>
                    </ul>
            </div>
        </nav>
    </>
  )
}

export default Navbar